var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.center},[_c('ContactSales',_vm._g({attrs:{"data-test-id":"ContactSalesModal__baseModal","handleChatButtonClick":_vm.handleChatButtonClick,"isChatLoading":_vm.isChatLoading,"showModal":_vm.showModal}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }